import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { useMemo, memo } from 'react';
import Table from '../../elements/Table/Table';
import TableBody from '../../elements/Table/TableBody';
import TableCell from '../../elements/Table/TableCell';
import TableHead from '../../elements/Table/TableHead';
import TableRow from '../../elements/Table/TableRow';
import useSpectrum from '../../hooks/useSpectrum';
import NoTableData from '../extra/placeholder/NoTableData';
import FiltersTable from './FiltersTable';
const styles = css `
  .btn {
    background-color: transparent;
    border: none;
    height: 25;
    width: 25;
    padding: 5px;
  }
  .filter-row {
    padding: 5px !important;
  }
  .filter-active {
    background-color: #f7f7f7;
    div,
    span,
    .btn {
      color: black !important;
    }

    li {
      background-color: transparent !important;
    }
  }
  .filter-current {
    background-color: #707070;
    div,
    span,
    .btn {
      color: white !important;
    }

    li {
      background-color: transparent !important;
    }
  }

  .filter-deactive {
    opacity: 0.3;
  }
`;
function FilterPanelInner({ filters }) {
    const filtersTable = useMemo(() => {
        return filters ? (_jsxs(Table, { children: [_jsx(TableHead, { children: _jsxs(TableRow, { children: [_jsx(TableCell, { align: "center", size: 1, children: "Label" }), _jsx(TableCell, { align: "center", size: 2, children: "Properties" })] }) }), _jsx(TableBody, { css: styles, children: _jsx(FiltersTable, {}) })] })) : (_jsx(NoTableData, {}));
    }, [filters]);
    return filtersTable;
}
const emptyData = { filters: [] };
const MemoizedFilterPanel = memo(FilterPanelInner);
export default function FilterPanel() {
    const { filters } = useSpectrum(emptyData);
    return _jsx(MemoizedFilterPanel, { filters: filters });
}
